import { Reducer } from 'redux';
import { FleetState, FleetTypes } from './types';

const INITIAL_STATE: FleetState = {
  carData: {
    id: '',
    license: '',
    prefix: '',
    model: '',
    sitCapacity: 0,
    footCapacity: 0,
    ticketer: false,
    accessible: false,
    airConditioned: false,
    age: 0,
    photoUrl: '',
    createdAt: '',
    updatedAt: '',
    vehicleCapacity: 0,
    wifi: false,
    bathroom: false,
  },
  reports: {
    '': {
      valuePerKm: 0,
      totalValue: 0,
      ipk: 0,
      ipke: 0,
      kvd: 0,
      pvd: 0,
      kpis: {
        ipk: 0,
        ipke: 0,
        valuePerKm: 0,
        kvd: 0,
        pvd: 0,
        trips: 0,
        km: 0,
        idleKm: 0,
      },
      benefits: {},
      benefitsCount: {},
    },
  },
  reportsQuantity: {
    '': {
      valuePerKm: 0,
      totalValue: 0,
      ipk: 0,
      ipke: 0,
      kvd: 0,
      pvd: 0,
      kpis: {
        ipk: 0,
        ipke: 0,
        valuePerKm: 0,
        kvd: 0,
        pvd: 0,
        trips: 0,
        km: 0,
        idleKm: 0,
      },
      benefits: {},
      benefitsCount: {},
    },
  },
  carSettingsData: {
    id: '',
    params: {
      motorcycle: 0,
      car: 0,
      wheelbarrow: 0,
      trailer: 0,
      lightTruck: 0,
      mediumTruck: 0,
      heavyTruck: 0,
    },
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
  },
  carsList: [],
  carsListFull: [],
  allCarsList: [],
  filterCarsList: [],

  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<FleetState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST CARS
    case FleetTypes.LIST_CARS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        ...(!action.payload?.isCsvFull && {
          companiesList: INITIAL_STATE.carsList,
        }),
      };
    case FleetTypes.LIST_CARS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ...(!action.payload?.isCsvFull && {
          carsList: action.payload.carsList,
        }),
        ...(action.payload?.isCsvFull && {
          carsListFull: action.payload.carsList,
        }),
        totalCount: action.payload.totalCount,
      };
    case FleetTypes.LIST_CARS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        carsList: INITIAL_STATE.carsList,
      };

    // CASES LIST ALL CARS
    case FleetTypes.LIST_ALL_CARS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        allCarsList: INITIAL_STATE.allCarsList,
      };
    case FleetTypes.LIST_ALL_CARS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        allCarsList: action.payload.allCarsList,
        totalCount: action.payload.totalCount,
      };
    case FleetTypes.LIST_ALL_CARS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        allCarsList: INITIAL_STATE.allCarsList,
      };

    // CASES GET CAR
    case FleetTypes.GET_CAR_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        carData: INITIAL_STATE.carData,
      };
    case FleetTypes.GET_CAR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        carData: action.payload.carData,
      };
    case FleetTypes.GET_CAR_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        carData: INITIAL_STATE.carData,
      };

    // CASES FILTER MONITORING CARS
    case FleetTypes.FILTER_MONITORING_CARS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        filterCarsList: INITIAL_STATE.filterCarsList,
      };
    case FleetTypes.FILTER_MONITORING_CARS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        filterCarsList: action.payload.filterCarsList,
        totalCount: action.payload.totalCount,
      };
    case FleetTypes.FILTER_MONITORING_CARS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        filterCarsList: INITIAL_STATE.filterCarsList,
      };

    // CASES FILTER CARS
    case FleetTypes.FILTER_CARS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        filterCarsList: INITIAL_STATE.filterCarsList,
      };
    case FleetTypes.FILTER_CARS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        filterCarsList: action.payload.filterCarsList,
        totalCount: action.payload.totalCount,
      };
    case FleetTypes.FILTER_CARS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        filterCarsList: INITIAL_STATE.filterCarsList,
      };

    // CASES CREATE CAR
    case FleetTypes.CREATE_CAR_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        carData: INITIAL_STATE.carData,
      };
    case FleetTypes.CREATE_CAR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        carData: action.payload.carData,
      };
    case FleetTypes.CREATE_CAR_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        carData: INITIAL_STATE.carData,
      };

    // CASES UPDATE CAR
    case FleetTypes.UPDATE_CAR_REQUEST:
      return { ...state, loading: true, error: false };
    case FleetTypes.UPDATE_CAR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        carData: action.payload.carData,
      };
    case FleetTypes.UPDATE_CAR_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE CAR
    case FleetTypes.DELETE_CAR_REQUEST:
      return { ...state, loading: true, error: false };
    case FleetTypes.DELETE_CAR_SUCCESS:
      return { ...state, loading: false, error: false };
    case FleetTypes.DELETE_CAR_FAILURE:
      return { ...state, loading: false, error: false };

    // CASES LIST REPORT CARS
    case FleetTypes.LIST_CARS_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        reports: INITIAL_STATE.reports,
      };
    case FleetTypes.LIST_CARS_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        reports: action.payload.reports,
      };
    case FleetTypes.LIST_CARS_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        reports: INITIAL_STATE.reports,
      };

    // CASES LIST REPORT CARS QUANTITY
    case FleetTypes.LIST_CARS_QUANTITY_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        reportsQuantity: INITIAL_STATE.reportsQuantity,
      };
    case FleetTypes.LIST_CARS_QUANTITY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        reportsQuantity: action.payload.reportsQuantity,
      };
    case FleetTypes.LIST_CARS_QUANTITY_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        reportsQuantity: INITIAL_STATE.reportsQuantity,
      };

    // CASE GET_CAR_SETTINGS_REQUEST
    case FleetTypes.GET_CAR_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        carSettingsData: INITIAL_STATE.carSettingsData,
      };
    case FleetTypes.GET_CAR_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        carSettingsData: action.payload.carSettingsData,
      };
    case FleetTypes.GET_CAR_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        carSettingsData: INITIAL_STATE.carSettingsData,
      };

    // CASE UPDATE_CAR_SETTINGS_REQUEST
    case FleetTypes.UPDATE_CAR_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        carSettingsData: INITIAL_STATE.carSettingsData,
      };
    case FleetTypes.UPDATE_CAR_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        carSettingsData: action.payload.carSettingsData,
      };
    case FleetTypes.UPDATE_CAR_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        carSettingsData: INITIAL_STATE.carSettingsData,
      };

    default:
      return state;
  }
};

export default reducer;
